module.exports = __webpack_public_path__ + "static/media/6.339306b4.svg";